<template>
  <div>
    <div v-if="showRefundInfo" class="message-box">
      <div>{{ refundInfo.statusStr }}：</div>
      <div>{{ refundInfo.remark }}</div>
    </div>
    <div class="card">
      <div class="content">
        <div class="title">
          基本信息
          <svg-icon class="state-style" v-if="detail.State" :class-name="detail.State + `-icon iconfont`" :icon-class="detail.State"></svg-icon>
        </div>
        <div class="justify-text">
          <div class="cell" v-if="detail.Type !== '余额退款'">
            <div class="li">合同编号</div>
            <div class="licontent">{{detail.ParentOrderCode}}</div>
          </div>
          <div class="cell">
            <div class="li">校区</div>
            <div class="licontent">{{detail.BizRegionInfo.Name}}</div>
          </div>
          <div class="cell">
            <div class="li">寝室</div>
            <div class="licontent">{{detail.FullAddress}}</div>
          </div>
          <div class="cell">
            <div class="li">申请时间</div>
            <div class="licontent">{{detail.CreateTimeStr}}</div>
          </div>
          <div class="cell" v-if="detail.Type !== '余额退款'">
            <div class="li">合同押金</div>
            <div class="licontent">￥{{detail.ParentOrderDeposit}}</div>
          </div>
          <div class="cell" v-if="detail.Type !== '余额退款'">
            <div class="li">合同租金</div>
            <div class="licontent">￥{{detail.ParentOrderPrice}}</div>
          </div>
          <div class="cell">
            <div class="li">申请金额</div>
            <div class="licontent">￥{{detail.Money}}</div>
          </div>
          <div class="cell">
            <div class="li">申请退款押金</div>
            <div class="licontent">￥{{detail.Deposit}}</div>
          </div>
          <div class="cell">
            <div class="li">申请退款租金</div>
            <div class="licontent">￥{{detail.Price}}</div>
          </div>
          <template v-if="detail.State === '待设置金额' || detail.State === '待退款' || detail.State === '已完成'">
            <div class="cell">
              <div class="li">实际退款金额</div>
              <div class="licontent">￥{{detail.ActualMoney}}</div>
            </div>
            <div class="cell">
              <div class="li">实际退款押金</div>
              <div class="licontent">￥{{detail.ActualDeposit}}</div>
            </div>
            <div class="cell">
              <div class="li">实际退款租金</div>
              <div class="licontent">￥{{detail.ActualPrice}}</div>
            </div>
          </template>
          <div class="cell">
            <div class="li">银行卡号</div>
            <div class="licontent">{{detail.BankNumber}}</div>
          </div>
          <div class="cell">
            <div class="li">开户银行</div>
            <div class="licontent">{{detail.Bank}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="content">
        <div class="title">
          退租信息
        </div>
        <div class="justify-text">
          <div class="cell">
            <div class="li">退租时间</div>
            <div class="licontent">{{detail.RentTimeStr }}</div>
          </div>
          <div class="textarea">
            <div class="li">退租原因</div>
            <div class="licontent">{{detail.RentReason || '暂无' }}</div>
          </div>
          <div class="textarea">
            <div class="li">{{detail.State!=='不通过' ? '指派内容': '备注'}}</div>
            <div class="licontent">{{detail.AssignRemarks || '暂无' }}</div>
          </div>
          <div class="textarea" v-if="detail.State!=='不通过'">
            <div class="li">审核备注</div>
            <div class="licontent">{{detail.Reply || '暂无' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="content">
        <div class="title">
          操作流程
        </div>
        <van-steps direction="vertical" :active="0">
          <van-step v-for="item in flow" :key="item.Id" class="step-group-item">
              <div class="time">
                {{ item.CreateTimeStr }}
              </div>
            <div class="title">{{ item.Type }}</div>
            <div class="text">
              {{ item.Text }}
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "refundDetail",
  data() {
    return {
      Id: "",
      detail: {
        BizRegionInfo: {}
      },
      flow: [],
      refundInfo: {},
      showRefundInfo: false
    };
  },
  methods: {
    async getRefundInfo() {
      try {
        const { Status, Data } = await this.$post('/BizMemberReturn/YyRemitQuery', { Id: this.$route.query.Id })
        if (Status === 1) {
          this.refundInfo = Data
          this.showRefundInfo = true
        }else {
          this.showRefundInfo = false
        }
      }catch (e) {
        this.showRefundInfo = false
      }
    },
    getDetail() {
      this.$post("/BizMemberReturn/Details", { Id: this.$route.query.Id }).then(
        async (res) => {
          if (res) {
            this.detail = res.Data;
            if (res.Data.State === '退款失败'){
              await this.getRefundInfo()
            }
          }
        }
      );
    },
    getFlow() {
      this.$post("/BizMemberReturnFlow/AllList", {
        ReturnId: this.$route.query.Id,
      }).then((res) => {
        if (res) {
          this.flow = res.Data;
        }
      });
    },
  },
  mounted() {
    this.getDetail();
    this.getFlow();
  },
};
</script>

<style lang="less" scoped>
.message-box{
  display: flex;
  background-color: #E06767;
  margin: 0.2rem;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 10px 15px;
  color: #ffffff;
  >div{
    &:nth-child(1){
      width: 80px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }
  }
}
.card {
  margin: 0.2rem;
  background-color: #fff;
  border-radius: 8px;
  color: #3D3D3D;

  .state-style{
    width: 80px;
    height: 80px;
    position: absolute;
    right: 20px;
    top: 10px;
  }

  .content {
    padding: 0.5rem;
    justify-content: space-between;
    position: relative;
    .title{
      display: flex;
      font-size: 18px;
      font-weight: bold;
      align-items: center;
      color: #333333;
    }

    .van-cell__value {
      min-width: 70%;
      color: black;
    }
  }
  .rightButton {
    display: flex;
    align-items: center;
  }
}
.justify-text {
  .cell {
    display: flex;
    margin-top: 10px;
    width: 100%;

    >div{
      width: 100%;

      &.li{
        width: 100px;
        flex-shrink: 0;
      }
      &.licontent{
        text-align: right;
      }
    }
  }

  .textarea{
    margin-top: 10px;
    .licontent{
      margin: 5px 0;
      background-color: #FAFAFA;
      padding: 10px;
      border-radius: 8px;
    }
  }
}

.step-group-item{
  .time{
    font-size: 12px;
    background-color: rgba(246, 246, 246);
    color: rgba(174, 174, 174);
    border-radius: 10px;
    padding: 2px 15px;
  }
  .title{
    font-size: 14px!important;
    margin: 15px 0 10px 0;
    color: #333333;
  }
  .text{
    font-size: 14px;
    word-break: break-all;
    color: rgba(174, 174, 174);
    line-height: 20px;
  }
}

</style>
